import React from 'react';
import PropTypes from 'prop-types';

import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';


const SiteDesignerRightSeoPreview = ({
   globalSettings,
}) => {
   const { getModifySectionGlobalSetting } = useSiteGlobalSettingsHelper(globalSettings);

   const seoSettings = getModifySectionGlobalSetting('seo_social_sharing')
   return (
      <div className='flex flex-col max-w-[550px] mx-auto'>
         <span>{seoSettings.title}</span>
         <span>{seoSettings.description}</span>
         {
            seoSettings.image_src && (
               <div className='relative rounded-lg overflow-hidden'>
                  <div className='aspect-video' />
                  <img src={ seoSettings.image_full_src } alt='seo-image' className=' absolute top-0 left-0 w-full h-auto' />
               </div>
            )
         }
         {/* {seoSettings.} */}
      </div>
   )
}

SiteDesignerRightSeoPreview.propTypes = {
   globalSettings: PropTypes.object,
}

export default SiteDesignerRightSeoPreview;
